import { render } from "./OutsideDepartmentListWidget.vue?vue&type=template&id=20176540&scoped=true&ts=true"
import script from "./OutsideDepartmentListWidget.vue?vue&type=script&lang=ts"
export * from "./OutsideDepartmentListWidget.vue?vue&type=script&lang=ts"

import "./OutsideDepartmentListWidget.vue?vue&type=style&index=0&id=20176540&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20176540"]])

export default __exports__